import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import meetingRoomReducer from './meetingSlice';

const persistConfig = {
  key: 'root',
  storage,
};

const persistedReducer = persistReducer(persistConfig, meetingRoomReducer);

const store = configureStore({
  reducer: {
    meetingRoom: persistedReducer,
  },
});

storage.removeItem('persist:root');

export const persistor = persistStore(store);
export default store;
